import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import _ from 'lodash';
import { position } from 'polished';
import { media, color, size } from '@deerplusofficial/pos-helper';
import { ButtonBase as Button, Icon } from '@deerplusofficial/pos-components';

const Container = styled.div`
  display: none;
  ${media(
    'tablet',
    css`
      display: block;
      padding-right: ${size.categoryTabToggle};
      height: ${props =>
        props.collapsed ? `calc(${size.categoryTabToggle} + 1px)` : 'auto'};
      max-height: calc(100vh - ${size.topbar.tablet} - ${size.productGap});
      overflow: ${props => (props.collapsed ? 'hidden' : 'auto')};
      border-bottom: 1px solid ${color.border};
      background-color: #ffffff;
    `
  )};
`;

const Tab = styled(Button)`
  padding: 0 24px;
  height: ${size.categoryTabToggle};
  color: ${color.text.title};
  ${props =>
    props.active &&
    css`
      box-shadow: inset 0 -3px 0 ${color.primary};
    `};
`;

const Toggle = styled(Button)`
  color: ${color.text.title};
  width: ${size.categoryTabToggle};
  height: ${size.categoryTabToggle};
  ${position('absolute', '0', '0', null, null)};
`;

const ToggleIcon = styled(Icon).attrs({ icon: 'ellipsis-v-alt' })`
  vertical-align: baseline;
`;

export default class CategoryTabSelector extends React.Component {
  static propTypes = {
    options: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string,
        value: PropTypes.string,
      })
    ),
    selected: PropTypes.string,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    options: [],
    selected: '',
    onChange: _.identity,
  };

  state = {
    collapsed: true,
  };

  onCollapseToggle = () => this.setState({ collapsed: !this.state.collapsed });

  render() {
    const { options, selected, onChange } = this.props;
    const { collapsed } = this.state;

    return (
      <Container collapsed={collapsed}>
        {_.map(options, ({ text, value }) => {
          return (
            <Tab
              key={value}
              active={selected === value}
              onClick={onChange}
              value={value}
            >
              {text}
            </Tab>
          );
        })}
        <Toggle onClick={this.onCollapseToggle}>
          <ToggleIcon />
        </Toggle>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProductLine/CategoryTabSelector.js